var moduleMap = {
	"./DemoDashboard": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(981), __webpack_require__.e(742)]).then(() => (() => ((__webpack_require__(6514)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(988), __webpack_require__.e(172), __webpack_require__.e(432), __webpack_require__.e(506)]).then(() => (() => ((__webpack_require__(5506)))));
	},
	"./server": () => {
		return Promise.all([__webpack_require__.e(988), __webpack_require__.e(520)]).then(() => (() => ((__webpack_require__(2520)))));
	},
	"./UnboxingPage": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(437), __webpack_require__.e(55)]).then(() => (() => ((__webpack_require__(3055)))));
	},
	"./UnboxingPageHeader": () => {
		return Promise.all([__webpack_require__.e(988), __webpack_require__.e(172), __webpack_require__.e(776), __webpack_require__.e(119), __webpack_require__.e(437), __webpack_require__.e(432), __webpack_require__.e(981), __webpack_require__.e(389), __webpack_require__.e(238)]).then(() => (() => ((__webpack_require__(4238)))));
	},
	"./UnboxingPageDescription": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(776), __webpack_require__.e(577)]).then(() => (() => ((__webpack_require__(3577)))));
	},
	"./UnboxingPageBody": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(437), __webpack_require__.e(57)]).then(() => (() => ((__webpack_require__(3057)))));
	},
	"./UnboxingPageRow": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(680), __webpack_require__.e(199)]).then(() => (() => ((__webpack_require__(1199)))));
	},
	"./UnboxingPageCol": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(583), __webpack_require__.e(860)]).then(() => (() => ((__webpack_require__(1860)))));
	},
	"./UnboxingPageContent": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(83)]).then(() => (() => ((__webpack_require__(9083)))));
	},
	"./UnboxingPageIntroduction": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(761), __webpack_require__.e(610), __webpack_require__.e(736)]).then(() => (() => ((__webpack_require__(9736)))));
	},
	"./UnboxingPageDocumentation": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(776), __webpack_require__.e(761), __webpack_require__.e(119), __webpack_require__.e(666), __webpack_require__.e(993)]).then(() => (() => ((__webpack_require__(6993)))));
	},
	"./UnboxingPageIntegrationBanner": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(776), __webpack_require__.e(704), __webpack_require__.e(48)]).then(() => (() => ((__webpack_require__(5048)))));
	},
	"./UnboxingPageCrossSelling": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(776), __webpack_require__.e(761), __webpack_require__.e(704), __webpack_require__.e(680), __webpack_require__.e(583), __webpack_require__.e(389), __webpack_require__.e(799), __webpack_require__.e(969)]).then(() => (() => ((__webpack_require__(2609)))));
	},
	"./UnboxingPageGetStarted": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(761), __webpack_require__.e(119), __webpack_require__.e(704), __webpack_require__.e(374)]).then(() => (() => ((__webpack_require__(3374)))));
	},
	"./UnboxingPageGetStartedSteps": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(481)]).then(() => (() => ((__webpack_require__(7481)))));
	},
	"./UnboxingPageGetStartedStepsItem": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(494)]).then(() => (() => ((__webpack_require__(2494)))));
	},
	"./UnboxingPageSwitch": () => {
		return Promise.all([__webpack_require__.e(172), __webpack_require__.e(119), __webpack_require__.e(373)]).then(() => (() => ((__webpack_require__(1373)))));
	},
	"./unboxing-page": () => {
		return __webpack_require__.e(778).then(() => (() => ((__webpack_require__(9778)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});